<script>
  import { onMount } from "svelte";
  onMount(() => {
    document.title =
      "How Puzzle Exchange Works | Missing Piece Puzzle Exchange";
  });

  let steps = [
    {
      title: "Choose Puzzle Pack or Subscription",
      image: "/assets/select_option.svg",
      descr:
        'Start with a one-time <a href="ways-to-rent#puzzle-pack">Puzzle Pack</a> rental or choose one of our <a href="ways-to-rent#casual-puzzler-plan">subscription plans</a> for a steady stream of puzzles.',
      link: "ways-to-rent",
    },
    {
      title: "Choose Puzzles",
      image: "/assets/how_choose.svg",
      descr:
        'Browse our wide selection of <a href="/rent">rentable puzzles</a> and select the ones you\'d like to piece together.',
      link: "/rent",
    },
    {
      title: "Receive Puzzles",
      image: "/assets/how_receive.svg",
      descr:
        "We'll ship your puzzle selections right to your doorstep! Puzzles come in bags with pictures of the puzzle.",
      link: "info/faq",
    },
    {
      title: "Return Puzzles",
      image: "/assets/how_return.svg",
      descr:
        'After you have finished your puzzles, ship them back using the provided shipping label. <a href="ways-to-rent">View our rental options now!</a>',
      link: "info/faq",
    },
  ];
</script>

<svelte:head>
  <title>How Puzzle Exchange Works | Missing Piece Puzzle Exchange</title>
  <meta
    name="description"
    content="Learn how Missing Piece Puzzle Exchange works. Choose a plan, pick your puzzles, receive them by mail, then return and repeat. Free shipping both ways."
  />
  <meta
    property="og:title"
    content="How Puzzle Exchange Works | Missing Piece Puzzle Exchange"
  />
  <meta
    property="og:description"
    content="Learn how Missing Piece Puzzle Exchange works. Choose a plan, pick your puzzles, receive them by mail, then return and repeat. Free shipping both ways."
  />
  <meta
    property="og:url"
    content="https://www.puzzleexchange.com/how-it-works"
  />
  <link rel="canonical" href="https://www.puzzleexchange.com/how-it-works" />
</svelte:head>

<main class="container">
  <!-- How it Works -->
  <section>
    <h2>How the Puzzle Exchange Works</h2>

    <ol class="info-steps">
      {#each steps as s, i}
        <li class="info-step card">
          <p class="step-title">
            <span class="step-icon">{i + 1}</span>
            {s.title}
          </p>
          <a href={s.link}>
            <img src={s.image} alt={s.title} />
          </a>
          <hr />
          <p>
            {@html s.descr}
          </p>
        </li>
      {/each}
    </ol>
  </section>
  <section class="add-questions">
    <h3>Still have questions?</h3>
    Check out our
    <a href="/info/faq">FAQ</a>
    or email us at
    <a href="mailto:info@puzzleexchange.com">info@puzzleexchange.com.</a>
  </section>
  <section class="pick-puzzle-btn">
    <a href="/rent">
      <button class="btn">Pick Puzzles</button>
    </a>
  </section>
</main>

<style type="text/less">
  .container {
    max-width: var(--content-width-sm);
    margin: auto;
  }

  .info-steps {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
    grid-gap: var(--spacing-xs);
  }

  .info-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 1 320px;
    margin: 0;

    p {
      text-align: center;
    }

    .step-title {
      font-weight: 700;
      margin: 0;
      display: flex;
      align-items: center;
      width: 100%;
    }

    .step-icon {
      font-size: 1.25rem;
      text-align: center;
      height: 2rem;
      background: var(--col-accent-2);
      border-radius: 50%;
      line-height: 1.75rem;
      color: var(--col-gray-100);
      margin-right: 0.5rem;
      flex: 0 0 2rem;
    }

    img {
      height: 15vw;
      min-height: 100px;
      max-height: 150px;
      margin: var(--spacing-sm) 0;
    }

    hr {
      border-color: var(--col-gray-80);
    }
  }

  .info-arrow {
    position: relative;
    align-self: center;
    font-size: 3rem;
    color: var(--col-accent-2);
    background: var(--col-gray-98);
    border: solid 1px var(--col-gray-90);
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    line-height: 2.1rem;
    margin: 0 -1.25rem;
  }

  .plan-options {
    display: flex;
    justify-content: space-between;

    .card {
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      flex: 0 1 320px;

      h3 {
        text-transform: uppercase;
      }

      a {
        margin-top: auto;
      }

      .icon {
        color: var(--col-accent-1);
        transform: translate(15%, -10%) rotate(25deg);
        font-size: 6rem;
        position: absolute;
        top: 0;
        right: 0;
        opacity: 0.35;
      }
    }
  }

  .add-questions {
    text-align: center;
    line-height: 3rem;
  }

  .pick-puzzle-btn {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }

  @media (max-width: 950px) {
    .info-steps {
      display: flex;
      flex-wrap: wrap;
    }

    .info-step {
      box-sizing: border-box;
      flex: 1 1 calc(50% - 0.5rem);
      min-width: 240px;
      margin: 0.25rem;
    }

    .info-arrow {
      display: none;
    }

    .plan-options {
      display: block;
    }

    .plan-options .btn {
      width: 100%;
    }
  }
</style>
